import { Box, Tooltip, IconButton } from "@material-ui/core";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";

export default function Pagination({ pagination, setPagination }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={1}
      marginLeft="6rem"
    >
      <Tooltip title="Última página">
        <IconButton
          onClick={() =>
            setPagination((prev) => ({ ...prev, page: prev.totalPages }))
          }
        >
          <KeyboardDoubleArrowRightIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Próxima página">
        <IconButton
          onClick={() =>
            setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
          }
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Página anterior">
        <IconButton
          onClick={() =>
            setPagination((prev) => ({ ...prev, page: prev.page - 1 }))
          }
        >
          <KeyboardArrowLeftIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Primeira página">
        <IconButton
          onClick={() => setPagination((prev) => ({ ...prev, page: 1 }))}
        >
          <KeyboardDoubleArrowLeftIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
